import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';
import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET,
    RESET,
    SETSELECTED_MEDITECH,
    RESET_MEDITECH
} from 'one-state-subject/src/types';

import {
    setAction, reinitAction
} from 'one-state-pcp/src/actions';

import {
    addAction, reinitAction as resetError
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton,
} from 'one-model-local';
import {format} from 'one-util-date';
export const enum Types {
    SETPCP = 'set-pcp-data/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
import { SET_MEDITECH } from 'one-state-patient-global-search';

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToPCP = (payload: any) => ({ type: Types.SETPCP, payload });
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data of PCP
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchPCPMeditech = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, alertnotification, settings: {
            servers,
            meditechendpoints: {
                getpcp
            },
            compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED_MEDITECH),
            // ofType(Types.PatientSet),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                let pcppayload: any = action.payload;
                const postPCPRequest = (datares: any) => {
                    if (datares?.id) {
                        let headers = new Headers();
                        const patientid = {
                            "MeditechID": datares?.id,
                        }
                        let response;
                        if (finesse_proxy_service) {
                            // response = InvokeFinesseProxy(getpcp, patientid, apitoken, locations, log, 'POST', alertnotification);

                        } else {
                            response =server.get({
                                headers: headers,
                                path: getpcp + "?PatientID=" + datares?.id
                            }).then((responsefound: any) => responsefound)
                                .catch((errorpcp: any) => {
                                    log.error(
                                        "ccw-gadget,pcp-meditech",
                                        "pcp-meditech", {
                                        errorpcp
                                    }
                                    );
                                    let errorbuild: ErrorObject = {
                                        source: "PCP",
                                        type: "error",
                                        status: errorpcp?.status,
                                        erroritems: errorpcp?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,pcp-meditech",
                                "pcp-meditech response", {
                                response
                            });
                        }
                        return from(response)
                    } else {
                        return from([]);
                    }

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return postPCPRequest(pcppayload).
                    pipe(
                        map((response: any) => TransformResponse(response, context))
                    ).
                    pipe(
                        flatMap(pcpresponse => {
                            const actions: any = [
                                setAction(pcpresponse.pcp)];
                            if (pcpresponse.error) {
                                actions.push(addAction(pcpresponse.error));
                                let disp: Disposition = { value: "1002" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = pcppayload?.id;
                                disp.meta03 = pcpresponse?.error?.error_code;
                                disp.meta04 = pcpresponse?.error?.error[0]?.error_description;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "185" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = pcpresponse?.id;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            let skeletonPatientCare: Skeleton = {
                                pendingCare_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonPatientCare));
                            return actions;
                        })
                    )
            })
        )
    }
);

export const clearPCPMeditech = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, pcp-meditech",
            "clear-PCP-meditech", {
        });
        return action$.pipe(
            ofType(SET_MEDITECH, SETSELECTED_MEDITECH, RESET, SETPATIENTSELECTED,RESET_MEDITECH),
            map(action => reinitAction())
        )

    }
);

export const clearErrorMeditech = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, pcp-meditech",
            "clear-Error-meditech", {
        });
        return action$.pipe(
            ofType(RESET,RESET_MEDITECH),
            map(action => resetError())
        )

    }
);